// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__EFJeY","success":"Alert_success__RejS2","error":"Alert_error__gqNt0","close":"Alert_close__cbR4a"};